import React from "react";

const TDCannedResponsesHeading = () => {
    return <h4>Canned Responses</h4>;
};

export default TDCannedResponsesHeading;
